var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { deleteAttendee, getQuestions, getSeats, postAttendeeTypes } from "../../../../../data/api";
import { GroupsMode } from "../../Register";
import { AppFormContext } from "../../../../../App";
import { ASTSection, Button, Form, Icon, IconButton, Text } from "@brushfire/ui";
import Popover from "@material-ui/core/Popover";
import { useDispatch, useSelector } from "react-redux";
import { getCartId, getLocal, LOCAL_STORAGE_KEYS, setLocal } from "../../../../../data/localStorageHelpers";
import { handleErrors } from "../../../../../data/helpers";
import useGroupData from "../../../../../hooks/useGroupData";
import { setCartData, setQuestionsData, updateCartStatus } from "../../../../../store/Cart/actions";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import Constants from "../../../../../data/constants";
import { clearInlineErrors, setFormIsSubmitting, setInlineError } from "../../../../../store/AppState/actions";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import Mini from "@brushfire/ui/dist/Elements/Text/Mini";
import AttendeeTypes from "../AttendeeTypes";
import InlineError from "../../../../UI/InlineError";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import { DropdownButton, Dropdown, Badge } from "react-bootstrap";
import { useZoom } from "../../../../../hooks/useZoom";
import Number from "../../../../UI/Number";
import { useSeatCode } from "../../../../../hooks/useSeatCode";
var useTypedSelector = useSelector;
var Section = function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme, eventData = _a.eventData, path = _a.path, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode, sections = _a.sections, fetchSections = _a.fetchSections, priceRange = _a.priceRange, seats = _a.seats, setSeats = _a.setSeats, typeCode = _a.typeCode;
    var _f = __read(useState(), 2), section = _f[0], setSection = _f[1];
    var _g = __read(useState(), 2), selectedType = _g[0], setSelectedType = _g[1];
    var _h = __read(useState([]), 2), selectedRows = _h[0], setSelectedRows = _h[1];
    var _j = __read(useState([]), 2), selectedSeats = _j[0], setSelectedSeats = _j[1];
    var _k = __read(useState(false), 1), isAdmin = _k[0];
    var _l = __read(useState(false), 2), isFetchingSeats = _l[0], setIsFetchingSeats = _l[1];
    var _m = __read(useState([]), 2), stagedSeats = _m[0], setStagedSeats = _m[1];
    var _o = __read(React.useState(null), 2), anchorEl = _o[0], setAnchorEl = _o[1];
    var _p = __read(React.useState(), 2), anchorSeatId = _p[0], setAnchorSeatId = _p[1];
    var _q = __read(useReducer(function (state, action) {
        var newState = state.concat();
        switch (action.type) {
            case "loading":
                return newState.concat(action.seats);
            case "done":
                return newState.filter(function (s) { return !action.seats.includes(s); });
        }
        return state;
    }, []), 2), loadingSeats = _q[0], setLoadingSeats = _q[1];
    var params = useParams();
    var dispatch = useDispatch();
    var formikContext = useContext(AppFormContext).formikContext;
    var history = useWidgetHistory();
    var search = useLocation().search.toLowerCase();
    var analytics = useWidgetAnalytics();
    var zoomState = useZoom();
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees; }).attendeeTypeData;
    var questionSubmitHistory = useTypedSelector(function (store) { return store.record; }).questionSubmitHistory;
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var _r = useTypedSelector(function (store) { return store.cart; }), cart = _r.cart, cartStatus = _r.cartStatus;
    var groupId = useGroupData((_b = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _b !== void 0 ? _b : 0).groupId;
    var accessKey = (_c = new URLSearchParams(search).get("access")) !== null && _c !== void 0 ? _c : "";
    var seatCode = useSeatCode().seatCode;
    var matrixTypes = (section === null || section === void 0 ? void 0 : section.id)
        ? attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (att) { return att.sections.find(function (sec) { return sec.sectionId === (section === null || section === void 0 ? void 0 : section.id); }); })
        : attendeeTypeData;
    var getSeatsLocal = function () {
        var _a;
        return getSeats((_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _a !== void 0 ? _a : 0, params.section, null, accessKey, null, groupId !== null && groupId !== void 0 ? groupId : null, seatCode);
    };
    var fetchSectionSeats = function () {
        var _a;
        var sectionToFetch = sections.find(function (s) {
            return s.name
                .replaceAll("%20", "")
                .replaceAll(" ", "")
                .toLowerCase() ===
                params.section
                    .replaceAll("%20", "")
                    .replaceAll(" ", "")
                    .toLowerCase();
        });
        if (eventData && ((_a = sectionToFetch === null || sectionToFetch === void 0 ? void 0 : sectionToFetch.isAssigned) !== null && _a !== void 0 ? _a : true)) {
            setIsFetchingSeats(true);
            getSeatsLocal()
                .then(function (_a) {
                var data = _a.data;
                setSeats(data);
                if (sections) {
                    var section_1 = sections.find(function (sec) { return sec.name === params.section; });
                    if (section_1) {
                        setSection(section_1);
                    }
                }
            })
                .finally(function () {
                setIsFetchingSeats(false);
            });
        }
        else if (sectionToFetch) {
            setSection(sectionToFetch);
        }
    };
    useEffect(function () {
        if (path === Constants.Routes.section && sections.length > 0 && seatCode !== undefined) {
            fetchSectionSeats();
        }
    }, [accessKey, seatCode, path, params.section, sections]);
    useEffect(function () {
        if (path === Constants.Routes.section && (sections === null || sections === void 0 ? void 0 : sections.length)) {
            var sectIndex = sections.findIndex(function (sec) { return sec.name.toLowerCase() === params.section.toLowerCase(); });
            if (sectIndex > -1) {
                setSection(sections[sectIndex]);
            }
            else {
                history.push(((eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? Constants.Routes.tickets : Constants.Routes.register)
                    .replace(":clientKey", params.clientKey)
                    .replace(":urlKey", params.urlKey)
                    .replace(":eventNumber", params.eventNumber.toString()));
            }
        }
    }, [sections, path]);
    var renderSectionHeader = function (allowRefresh, loading, allowZoom) {
        if (allowRefresh === void 0) { allowRefresh = true; }
        if (loading === void 0) { loading = false; }
        if (allowZoom === void 0) { allowZoom = true; }
        return (_jsxs("div", __assign({ className: "ast-section-header d-flex b-bottom" }, { children: [sections.length > 1 && (_jsx(IconButton, { onClick: goBackToVenue, icon: "arrow-left", classes: "m-right", ariaLabel: "Go Back to Venue Map" })), allowRefresh && (_jsx(IconButton, { icon: "sync ".concat(isFetchingSeats || loading ? "fa-spin" : ""), classes: "m-right", ariaLabel: "Refresh Section", onClick: function () {
                        fetchSectionSeats();
                    } })), allowZoom && (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: zoomState.zoomOut, icon: "search-minus", ariaLabel: "Zoom Out", classes: "m-right", disabled: zoomState.scale === zoomState.bounds.lower }), _jsx(IconButton, { onClick: zoomState.zoomIn, icon: "search-plus", ariaLabel: "Zoom In", disabled: zoomState.scale === zoomState.bounds.upper, classes: "m-right" })] })), section && sections.length > 1 && (_jsx("div", __assign({ className: "flex-1 ta-right" }, { children: _jsx(DropdownButton, __assign({ id: "section-dropdown", className: "m-right-sm border-0 d-inline-block", variant: "dark", title: _jsxs(_Fragment, { children: ["Section ", params.section, " ", _jsx(Icon, { icon: "chevron-down" })] }), menuAlign: "right" }, { children: sections === null || sections === void 0 ? void 0 : sections.map(function (section) {
                            var hasAvailableSeats = section.spotsRemaining !== 0 &&
                                section.reservedStates.some(function (s) { return s.reservedState.id === 0 || s.reservedState.id === 4; }); // available or handicap seats
                            return (_jsx(Dropdown.Item, __assign({ onClick: function (evt) {
                                    evt.stopPropagation();
                                    evt.preventDefault();
                                    if (section.name.toLowerCase() !== params.section.toLowerCase()) {
                                        goToSection(section.name);
                                    }
                                }, disabled: section.name.toLowerCase() === params.section.toLowerCase() ||
                                    !hasAvailableSeats }, { children: "".concat(section.name).concat(!hasAvailableSeats ? " (Sold Out)" : "") }), section.name));
                        }) })) })))] })));
    };
    var goBackToVenue = function () {
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber;
            var url = "".concat(((eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets" ? Constants.Routes.tickets : Constants.Routes.register)
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString())).concat(seatCode ? "?seatcode=".concat(seatCode) : "");
            history.push(url);
        }
    };
    var goToSection = function (sectionName) {
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber;
            var url = "".concat(Constants.Routes.section
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString())
                .replace(":section", sectionName)).concat(seatCode ? "?seatcode=".concat(seatCode) : "");
            history.push(url);
        }
    };
    var continueToQuestions = function () {
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber;
            var url = Constants.Routes.questions
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString())
                .replace(Constants.Regex.guid, "")
                .replace(":attendeeId", "");
            history.push(url);
        }
    };
    var continueToCart = function () {
        if (eventData) {
            var clientKey = eventData.clientKey, urlKey = eventData.urlKey, eventNumber = eventData.eventNumber;
            var url = Constants.Routes.cart
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber.toString());
            history.push(url);
        }
    };
    if (!section || !eventData) {
        return (_jsx(_Fragment, {}));
    }
    if (!section.isAssigned) {
        if (matrixTypes) {
            return (_jsxs(_Fragment, { children: [renderSectionHeader(false, false, false), !isFetchingSeats && (_jsx("div", __assign({ className: "mt-4" }, { children: _jsx(AttendeeTypes, { section: section, eventData: eventData, theme: theme, path: path, activePaths: [Constants.Routes.section], groupsMode: groupsMode, setGroupsMode: setGroupsMode, attendeeTypeData: matrixTypes, typeCode: typeCode, setSourceAttendee: function () { return null; } }) })))] }));
        }
        else {
            return null;
        }
    }
    if (!seats) {
        return null;
    }
    var onSelectedSeats = function (seats, target) {
        var _a, _b, _c;
        var newSeats = selectedSeats.concat();
        if (seats.length === 1 && seats[0].wheelchair && !((_a = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _a === void 0 ? void 0 : _a.find(function (a) { return a.seatId === seats[0].seatId; }))) {
            setAnchorEl(target);
            setAnchorSeatId(seats[0].seatId);
        }
        else if (seats.length === 1 &&
            seats[0].limitedView &&
            !((_b = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _b === void 0 ? void 0 : _b.find(function (a) { return a.seatId === seats[0].seatId; }))) {
            setAnchorEl(target);
            setAnchorSeatId(seats[0].seatId);
        }
        else {
            var availableSeats_1 = seats.filter(function (seat) { return seat.available && !seat.inaccessibleDueToAccessCode; });
            var seatIds_1 = availableSeats_1.map(function (s) { return s.seatId; });
            var allSeatIds_1 = seats.map(function (s) { return s.seatId; });
            var attendeeToRemove_1 = (_c = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _c === void 0 ? void 0 : _c.find(function (a) { return a.seatId === allSeatIds_1[0]; });
            if (attendeeToRemove_1 && section.distanceCount <= 0 && allSeatIds_1.length === 1 && cart) {
                dispatch(setFormIsSubmitting(true));
                setLoadingSeats({ type: "loading", seats: allSeatIds_1 });
                deleteAttendee(cart.cartId, attendeeToRemove_1.attendeeId, eventData.eventNumber.toString())
                    .then(function (_a) {
                    var data = _a.data;
                    var cartData = data;
                    newSeats = newSeats.filter(function (seatId) {
                        return !allSeatIds_1.includes(seatId);
                    });
                    setSelectedSeats(newSeats);
                    getSeatsLocal()
                        .then(function (_a) {
                        var data = _a.data;
                        setSeats(data);
                        dispatch(setCartData(cartData));
                        setAnchorEl(null);
                        setAnchorSeatId(undefined);
                        setStagedSeats([]);
                        dispatch(setFormIsSubmitting(false));
                    })
                        .finally(function () {
                        setLoadingSeats({ type: "done", seats: allSeatIds_1 });
                    });
                    analytics.removeFromCart([attendeeToRemove_1], eventData);
                })
                    .catch(function (err) {
                    handleErrors(err, dispatch, formikContext);
                    dispatch(setFormIsSubmitting(false));
                    setLoadingSeats({ type: "done", seats: allSeatIds_1 });
                });
            }
            else {
                if (availableSeats_1.some(function (s) { return !selectedSeats.includes(s.seatId); })) {
                    availableSeats_1.forEach(function (s) {
                        if (!selectedSeats.includes(s.seatId)) {
                            newSeats.push(s.seatId);
                        }
                    });
                    setSelectedSeats(newSeats);
                    if (availableSeats_1.every(function (s) { return s.types.length === 1; })) {
                        if (availableSeats_1[0].limitedView) {
                            setAnchorEl(target);
                            setAnchorSeatId(availableSeats_1[0].seatId);
                        }
                        if (section.distanceCount > 0) {
                            var attendeeType_1 = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === availableSeats_1[0].types[0]; });
                            setStagedSeats(__spreadArray(__spreadArray([], __read(stagedSeats), false), __read(availableSeats_1.map(function (seat) {
                                var _a;
                                return ({
                                    typeId: seat.types[0],
                                    quantity: 1,
                                    groupId: groupId !== null && groupId !== void 0 ? groupId : null,
                                    amount: (_a = attendeeType_1 === null || attendeeType_1 === void 0 ? void 0 : attendeeType_1.amount) !== null && _a !== void 0 ? _a : 0,
                                    isPreRegistered: false,
                                    seatId: seat.seatId,
                                    sectionId: !section.isAssigned ? seat.sectionId : null,
                                    externalId: "",
                                    externalDescription: "",
                                });
                            })), false));
                        }
                        else {
                            //Add to Cart
                            addSeatsToCart({
                                eventNumber: eventData.eventNumber,
                                attendees: availableSeats_1.map(function (seat) { return ({
                                    typeId: seat.types[0],
                                    quantity: 1,
                                    groupId: groupId !== null && groupId !== void 0 ? groupId : null,
                                    amount: seat.unitPrice,
                                    isPreRegistered: false,
                                    seatId: seat.seatId,
                                    sectionId: !section.isAssigned ? seat.sectionId : null,
                                    externalId: "",
                                    externalDescription: "",
                                }); }),
                                sourceAttendeeId: null,
                                typeCode: "",
                            });
                        }
                    }
                    else {
                        //Show type picker
                        setAnchorEl(target);
                        setAnchorSeatId(availableSeats_1[0].seatId);
                    }
                }
                else {
                    newSeats = newSeats.filter(function (seatId) {
                        return !seatIds_1.includes(seatId);
                    });
                    setSelectedSeats(newSeats);
                    var newStagedSeats = stagedSeats.concat();
                    var seatsToRemove_1 = seats.map(function (s) { return s.seatId; });
                    newStagedSeats = newStagedSeats.filter(function (seat) {
                        var _a;
                        return !seatsToRemove_1.includes((_a = seat.seatId) !== null && _a !== void 0 ? _a : "");
                    });
                    setStagedSeats(newStagedSeats);
                    setAnchorEl(null);
                    setAnchorSeatId(undefined);
                }
            }
        }
    };
    var handleClose = function () {
        setAnchorEl(null);
        setAnchorSeatId(undefined);
        setSelectedSeats([]);
        setSelectedType(undefined);
    };
    var addSeatsToCart = function (cartInput, formikHelpers) {
        dispatch(setFormIsSubmitting(true));
        var seatIds = cartInput.attendees.map(function (a) { var _a; return (_a = a.seatId) !== null && _a !== void 0 ? _a : ""; });
        setLoadingSeats({ type: "loading", seats: seatIds });
        dispatch(clearInlineErrors());
        postAttendeeTypes(getCartId(eventData.eventNumber), cartInput)
            .then(function (_a) {
            var data = _a.data;
            var cartData = data.cart;
            if (section.distanceCount <= 0) {
                //Socially Distanced Section
                dispatch(setCartData(cartData));
                setAnchorEl(null);
                setAnchorSeatId(undefined);
                setStagedSeats([]);
                formikHelpers === null || formikHelpers === void 0 ? void 0 : formikHelpers.setSubmitting(false);
                dispatch(setFormIsSubmitting(false));
                setSelectedType(undefined);
                setLoadingSeats({ type: "done", seats: seatIds });
            }
            else {
                //Socially Distanced Section
                getSeatsLocal()
                    .then(function (_a) {
                    var data = _a.data;
                    setSeats(data);
                    dispatch(setCartData(cartData));
                    setAnchorEl(null);
                    setAnchorSeatId(undefined);
                    setStagedSeats([]);
                    formikHelpers === null || formikHelpers === void 0 ? void 0 : formikHelpers.setSubmitting(false);
                    dispatch(setFormIsSubmitting(false));
                })
                    .finally(function () {
                    setSelectedType(undefined);
                    setLoadingSeats({ type: "done", seats: seatIds });
                });
            }
            fetchSections();
            dispatch(updateCartStatus({
                isLoading: false,
                timesLoaded: cartStatus.timesLoaded + 1,
            }));
            analytics.addToCart(cartInput, eventData);
            if (cartData.communityLimitExceeded) {
                dispatch(setInlineError({ registerHeaderError: cartData.error }));
                dispatch(setCartData(cartData));
                dispatch(setFormIsSubmitting(false));
            }
        })
            .catch(function (err) {
            var _a, _b, _c, _d;
            handleErrors(err, dispatch, formikContext);
            if ((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                dispatch(setInlineError({ sectionError: (_d = (_c = err.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.message }));
            }
            formikHelpers === null || formikHelpers === void 0 ? void 0 : formikHelpers.setSubmitting(false);
            dispatch(setFormIsSubmitting(false));
            setLoadingSeats({ type: "done", seats: seatIds });
            setSelectedType(undefined);
            getSeatsLocal().then(function (_a) {
                var data = _a.data;
                setSeats(data);
            });
            setStagedSeats([]);
        });
    };
    var addSeatToCart = function (typeId, amount, seatId, sectionId) {
        var attendee = {
            typeId: typeId,
            quantity: 1,
            groupId: groupId !== null && groupId !== void 0 ? groupId : null,
            amount: amount,
            isPreRegistered: false,
            seatId: seatId,
            sectionId: sectionId,
            externalId: "",
            externalDescription: "",
        };
        var payload = {
            eventNumber: eventData.eventNumber,
            attendees: [attendee],
            typeCode: "",
            sourceAttendeeId: null,
        };
        if (section.distanceCount > 0) {
            setStagedSeats(__spreadArray(__spreadArray([], __read(stagedSeats), false), [attendee], false));
            setSelectedType(undefined);
            setAnchorEl(null);
            setAnchorSeatId(undefined);
        }
        else {
            addSeatsToCart(payload);
        }
    };
    var onSubmit = function (values, formikHelpers) {
        var _a;
        if (stagedSeats.length > 0) {
            var payload = {
                eventNumber: eventData.eventNumber,
                attendees: stagedSeats,
                typeCode: "",
                sourceAttendeeId: null,
            };
            addSeatsToCart(payload, formikHelpers);
        }
        else if ((_a = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _a === void 0 ? void 0 : _a.length) {
            if (cart.attendees.every(function (a) {
                return a.canContinue &&
                    (!a.hasFields ||
                        (questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(a.attendeeId)) ||
                        (a.isPreRegistered && isAutoRegMode));
            }) &&
                cart.canContinue &&
                (!cart.hasFields || (questionSubmitHistory === null || questionSubmitHistory === void 0 ? void 0 : questionSubmitHistory.submittedForms.includes(cart.cartId)))) {
                formikHelpers.setSubmitting(false);
                continueToCart();
                getQuestions(cart.cartId, cart.eventNumber.toString()).then(function (_a) {
                    var data = _a.data;
                    dispatch(setQuestionsData(data));
                });
            }
            else {
                getQuestions(cart.cartId, cart.eventNumber.toString()).then(function (_a) {
                    var data = _a.data;
                    dispatch(setQuestionsData(data));
                    continueToQuestions();
                    formikHelpers.setSubmitting(false);
                });
            }
        }
    };
    if (!attendeeTypeData) {
        return null;
    }
    var targetSeat = seats.find(function (s) { return s.seatId === anchorSeatId; });
    var targetTypes = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.filter(function (a) { return targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types.includes(a.id); });
    targetTypes === null || targetTypes === void 0 ? void 0 : targetTypes.forEach(function (type) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        type.amount = (_b = (_a = type.prices.find(function (p) { return p.basePrice === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.unitPrice); })) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : null;
        type.fee = (_d = (_c = type.prices.find(function (p) { return p.basePrice === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.unitPrice); })) === null || _c === void 0 ? void 0 : _c.fee) !== null && _d !== void 0 ? _d : null;
        type.tax = (_f = (_e = type.prices.find(function (p) { return p.basePrice === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.unitPrice); })) === null || _e === void 0 ? void 0 : _e.tax) !== null && _f !== void 0 ? _f : null;
        type.displayAmount = (_h = (_g = type.prices.find(function (p) { return p.basePrice === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.unitPrice); })) === null || _g === void 0 ? void 0 : _g.displayAmount) !== null && _h !== void 0 ? _h : 0;
        type.priceDescription = (_k = (_j = type.prices.find(function (p) { return p.basePrice === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.unitPrice); })) === null || _j === void 0 ? void 0 : _j.priceDescription) !== null && _k !== void 0 ? _k : "";
    });
    var targetAllZero = targetTypes === null || targetTypes === void 0 ? void 0 : targetTypes.every(function (type) { return type.amount === 0 || type.amount === null; });
    var targetAvailabilityIsEqual = targetTypes === null || targetTypes === void 0 ? void 0 : targetTypes.every(function (a, i, arr) { return a.available === arr[0].available; });
    return (_jsxs(_Fragment, { children: [_jsx(InlineError, { id: "sectionError" }), renderSectionHeader(), _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: stagedSeats.length > 0 ? "Add To Cart" : "Continue",
                    hideButton: stagedSeats.length === 0 && ((_e = (_d = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) === 0,
                } }, { children: function (_a) {
                    var _b;
                    var formikContext = _a.formikContext;
                    return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path.replace(":sectionId", section.id), path: Constants.Routes.section.replace(":sectionId", section.id), formikContext: formikContext, active: groupsMode === GroupsMode.hide || groupsMode === GroupsMode.noGroups }), _jsx(ASTSection, { eventData: eventData, section: section, seats: seats, onSelectSeats: onSelectedSeats, onSelectRow: function (seats) {
                                    if (!selectedRows.includes(seats[0].rowName)) {
                                        selectedRows.push(seats[0].rowName);
                                        setSelectedRows(selectedRows);
                                    }
                                    else {
                                        setSelectedRows(selectedRows.filter(function (s) { return s === seats[0].rowName; }));
                                    }
                                }, selectedSeats: selectedSeats, selectedRows: selectedRows, loadingSeats: loadingSeats, cart: cart, isAdmin: isAdmin, priceRange: priceRange, isInclusiveFees: attendeeTypeData.some(function (a) { return a.isInclusiveFees; }), attendeeTypeData: attendeeTypeData, hasDismissedCoachmark: getLocal(LOCAL_STORAGE_KEYS.HAS_DISMISSED_AST_COACHMARK) === "true", dismissCoachmark: function () {
                                    setLocal(LOCAL_STORAGE_KEYS.HAS_DISMISSED_AST_COACHMARK, "true");
                                }, scale: zoomState.scale }), _jsx(Popover, __assign({ id: "seat-popover", className: (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.wheelchair) && targetSeat.state.id !== 0
                                    ? "seat-popover-info"
                                    : "seat-popover", open: !!anchorEl && !!anchorSeatId, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "right",
                                }, transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                }, elevation: undefined }, { children: (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.wheelchair) && targetSeat.state.id !== 0 ? (_jsxs("div", { children: [_jsxs("h6", __assign({ className: "bold" }, { children: ["For special needs seating, please call ", eventData.contactPhone, "."] })), _jsx("small", { children: "Spots with a wheelchair icon are intended for a wheelchair -- no seat is present." })] })) : (_jsxs(_Fragment, { children: [_jsxs("h6", __assign({ className: "bold" }, { children: [targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.seatType, " ", targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.seatLabel, " ", !(targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.limitedView) &&
                                                    " - Choose\n\t\t\t\t\t\t\t\t\t\t\t".concat(eventData.verbiage === "Tickets" ? "Ticket" : "Registration", " Type")] })), (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.limitedView) && (_jsx("small", { children: "By selecting this seat, you acknowledge that the view of the stage from this seat is limited or obstructed." })), (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.wheelchair) && (_jsx("small", { children: "Spots with a wheelchair icon are intended for a wheelchair -- no seat is present." })), targetSeat && (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types.length) > 1 ? (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types.sort(function (a, b) {
                                            var _a, _b, _c, _d;
                                            var d1 = (_b = (_a = attendeeTypeData.find(function (c) { return c.id === a; })) === null || _a === void 0 ? void 0 : _a.displayOrder) !== null && _b !== void 0 ? _b : 0;
                                            var d2 = (_d = (_c = attendeeTypeData.find(function (c) { return c.id === b; })) === null || _c === void 0 ? void 0 : _c.displayOrder) !== null && _d !== void 0 ? _d : 0;
                                            return d1 - d2;
                                        }).map(function (type) {
                                            var _a, _b, _c;
                                            var attendeeType = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === type; });
                                            var isDisabled = !(attendeeType === null || attendeeType === void 0 ? void 0 : attendeeType.isAvailable) ||
                                                (attendeeType === null || attendeeType === void 0 ? void 0 : attendeeType.soldOut) ||
                                                !!(groupId && (attendeeType === null || attendeeType === void 0 ? void 0 : attendeeType.notYourGroup));
                                            if (attendeeType && anchorSeatId) {
                                                return (_jsx(Button, __assign({ purpose: selectedType === type ? "success" : "light", disabled: isDisabled, classes: (selectedType && selectedType !== type) ||
                                                        isDisabled
                                                        ? "disabled"
                                                        : "", onClick: function () {
                                                        var _a;
                                                        if (!selectedType && !isDisabled) {
                                                            setSelectedType(type);
                                                            addSeatToCart(type, (_a = attendeeType.amount) !== null && _a !== void 0 ? _a : 0, anchorSeatId, section.isAssigned ? null : section.id);
                                                        }
                                                    } }, { children: _jsxs("div", __assign({ className: "d-flex justify-space-between" }, { children: [_jsxs("div", __assign({ style: { textAlign: "left" } }, { children: [_jsxs("span", __assign({ className: "p-0 m-0 attendee-name" }, { children: [_jsx("span", __assign({ className: "word-break" }, { children: attendeeType.name })), attendeeType.soldOut && (_jsx(Badge, __assign({ className: "m-left-sm m-bottom-sm", variant: "danger" }, { children: "Sold Out" }))), attendeeType.isFuture &&
                                                                                !attendeeType.soldOut && (_jsx(Badge, __assign({ className: "m-left-sm m-bottom-sm", variant: "secondary" }, { children: "Upcoming" }))), attendeeType.isAccessibleBecauseOfAccessCode &&
                                                                                !attendeeType.soldOut && (_jsx(Badge, __assign({ className: "m-left-sm m-bottom-sm", variant: "secondary" }, { children: "Unlocked" }))), attendeeType.isPast &&
                                                                                !attendeeType.soldOut && (_jsx(Badge, __assign({ className: "m-left-sm m-bottom-sm", variant: "secondary" }, { children: "Expired" }))), attendeeType.yourGroup &&
                                                                                (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types.length) !== 1 && (_jsx(Badge, __assign({ className: "your-group-badge m-left-sm m-bottom-sm", variant: "secondary" }, { children: "Your Group" }))), !!(groupId && attendeeType.notYourGroup) && (_jsx(Badge, __assign({ className: "your-group-badge m-left-sm m-bottom-sm", variant: "light" }, { children: "Not Your Group" })))] })), !targetAvailabilityIsEqual && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs(Mini, { children: [attendeeType.available.startsWith("Ends")
                                                                                        ? ""
                                                                                        : "Available ", attendeeType.available] })] }))] })), !targetAllZero && attendeeType.amount !== null && (_jsxs("div", __assign({ style: {
                                                                    paddingLeft: "10px",
                                                                    textAlign: "right",
                                                                } }, { children: [_jsx(Number, { value: attendeeType.displayAmount, style: "currency", currency: (_a = eventData === null || eventData === void 0 ? void 0 : eventData.currency) !== null && _a !== void 0 ? _a : "USD" }), attendeeType.isInclusiveFees ? (_jsx(Text.Mini, { children: attendeeType.priceDescription })) : (_jsx(_Fragment, { children: attendeeType.fee ? (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs(Text.Mini, { children: ["+", _jsx(Number, { value: (_b = attendeeType.fee) !== null && _b !== void 0 ? _b : 0, style: "currency", currency: (_c = eventData === null || eventData === void 0 ? void 0 : eventData.currency) !== null && _c !== void 0 ? _c : "USD" })] })] })) : null }))] })))] })) }), type));
                                            }
                                        })) : (_jsx(Button, __assign({ purpose: "light", onClick: function () {
                                                var _a;
                                                if (targetSeat && !selectedType && anchorSeatId) {
                                                    var attendeeType = attendeeTypeData === null || attendeeTypeData === void 0 ? void 0 : attendeeTypeData.find(function (a) { return a.id === (targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types[0]); });
                                                    setSelectedType(targetSeat === null || targetSeat === void 0 ? void 0 : targetSeat.types[0]);
                                                    attendeeType &&
                                                        addSeatToCart(targetSeat.types[0], (_a = attendeeType.amount) !== null && _a !== void 0 ? _a : 0, anchorSeatId, section.isAssigned ? null : section.id);
                                                }
                                            } }, { children: _jsx("div", __assign({ className: "d-flex justify-content-center" }, { children: _jsx("div", __assign({ style: { textAlign: "center" } }, { children: "Add Seat To Cart" })) })) })))] })) })), ((_b = formikContext.status) === null || _b === void 0 ? void 0 : _b.menuOpen) && _jsx("div", { className: "react-select-menu-buffer extra" })] }));
                } }))] }));
};
export default Section;
